const Ured = () => {
    return (
        <h1>
            O nama
        </h1>
    )
};

export default Ured;